module.exports = __webpack_public_path__ + "img/joy_sp_05.5d2eb076.png";